<div class="modal-container">
  <div [ngStyle]="{'direction': lang == 'ar' ? 'rtl' : 'ltr' }" class="header-dialog">
    <h3 class="modal-title p-0" mat-dialog-title>{{RecivedData.title}}</h3>
    <button class="btn-x" (click)="Canel(true)">X</button>
  </div>

  <div mat-dialog-content>
    <ng-template dialogHost></ng-template>
  </div>

  <div mat-dialog-actions class="justify-content-end">
    <button *ngIf="RecivedData.hasCancelBtn" mat-button (click)="Canel()"
      class="btn outline">{{RecivedData.secondButtonName?RecivedData.secondButtonName:'Cancel' | translate}}</button>
    <button *ngIf="RecivedData.hasOkBtn" mat-button (click)="Ok()"
      class="primary-btn ms-2">{{RecivedData.firstButtonName?RecivedData.firstButtonName:'Ok' | translate}}</button>
  </div>
</div>